import { IGetMenusResponseMenu } from 'src/api/getMenus/types';
import { IMenu } from 'src/types/menu.types';
import { findImageUrl, findPDFAsset } from 'src/hooks/useMenu/formatMenu/formatMenu';

export const getMenusService = (menus: IGetMenusResponseMenu[]): IMenu[] => {
  return menus.map((menu) => ({
    menuId: menu.menu_id,
    name: menu.name,
    consumerName: menu.consumer_name,
    description: menu.description,
    image: findImageUrl(menu.assets),
    allergensPDF: findPDFAsset(menu.assets),
    uncategorised: [],
    modifiers: [],
    sections: [],
    schedules: [],
    publication: {
      publicationStatus: 'UNPUBLISHED',
      scheduledPublicationDate: menu.publication?.scheduled_publication_date
        ? new Date(menu.publication.scheduled_publication_date)
        : null,
      aggregators: [],
      publicationDate: new Date(),
      eventId: null,
    },
    created: new Date(menu.create_date),
    linkedVenueIds: new Set(),
    mealtimes: [],
    ranges: menu.ranges,
  }));
};
